
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiPls as ObiPlsElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-pls.js';
 
 
 

 
 export const ObiPls = createComponent({
   react: React,
   tagName: 'obi-pls',
   elementClass: ObiPlsElement,
   events: {
     
   }
  });
 
 